<template>
    <div id="cards_mobile" v-bind:class="{ active: active }" v-bind:style="{ height: window_height }">
        <img id="card_slider_logo" src="../assets/img/card_slider_logo.svg" />
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="card in cards">
                    <router-link v-bind:to="{ name: 'card_open', params: { card_number: card.fields.cardNumber } }">
                        <div class="slide_card" v-bind:class="[card.fields.cardType.toLowerCase(), { disclaimer: card.fields.disclaimer }]">
                            <div v-if="card.fields.image" class="slide_card_image" v-bind:style="{ 'background-image': 'url(' + card.fields.image + ')' }"></div>
                            <div class="slide_content_layer">
                                <p class="slide_card_number">{{ card.fields.cardNumber | card_number }}</p>
                                <div class="slide_card_content">
                                    <p class="slide_card_title card_title" >{{ card.fields.cardTitle }}</p>
                                    <p v-if="card.fields.sponsored" class="slide_card_sponsored">presented by toyota c-hr</p>
                                    <p class="slide_card_teaser">{{ card.fields.cardTeaserCopy }}</p>
                                </div>
                                <router-link v-on:click="mobile_ga(card.fields.cardNumber)" v-bind:to="{ name: 'card_open', params: { card_number: card.fields.cardNumber } }" class="slide_card_button">
                                    <button>learn more</button>
                                </router-link>
                                <img v-if="card.fields.cardType.toLowerCase() == 'do'" class="slide_card_icon" src="../assets/img/do.svg" />
                                <img v-else-if="card.fields.cardType.toLowerCase() == 'listen'" class="slide_card_icon" src="../assets/img/listen.svg" />
                                <img v-else-if="card.fields.cardType.toLowerCase() == 'make'" class="slide_card_icon" src="../assets/img/make.svg" />
                                <img v-else-if="card.fields.cardType.toLowerCase() == 'buy'" class="slide_card_icon" src="../assets/img/buy.svg" />
                                <img v-else="card.fields.cardType.toLowerCase() == 'watch'" class="slide_card_icon" src="../assets/img/watch.svg" />
                                <p v-if="card.fields.disclaimer" class="slide_card_sponsored disclaimer">{{ card.fields.disclaimer }}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="swiper-slide">
                    <div id="card_slider_legal" class="legal">
                        <p class="copyright">© 2016 REFINERY29</p>
                        <p>BY USING OUR SERVICE, YOU AGREE TO OUR <a href="http://www.refinery29.com/terms-and-conditions" style="color:inherit;" target="_blank">TERMS</a> (EFFECTIVE 2/07/2017) AND <a href="http://www.refinery29.com/privacy" style="color:inherit;" target="_blank">PRIVACY</a> (EFFECTIVE 2/07/2017).</p>
                        <p>REFINERY29 NAME & LOGO AND R29 LOGO ARE TRADEMARKS OF REFINERY 29 INC.</p>
                    </div>
                </div>
            </div>
            <i v-show="!card_swiper.isBeginning" class="swiper-prev fa fa-chevron-left" aria-hidden="true"></i>
            <i v-show="!card_swiper.isEnd" class="swiper-next fa fa-chevron-right" aria-hidden="true"></i>
        </div>
        <div id="card_slider_progress">
            <div id="progress_bar"></div>
            <div id="progress_point" v-on:touchmove="slide_progress" v-bind:style="{ left: progress_point_position }"></div>
        </div>
    </div>
</template>

<script>
    import swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    import anime from 'animejs';

    export default {
        name: 'cards-mobile',
        props: ['active', 'cards'],
        data: function() {
            return {
                card_swiper: {},
				timeline: null,
                progress_point_position: '',
				window_height: ''
            }
        },
        methods: {
            slide_progress: function(e) {
                let gutter = window.innerWidth * 0.1;
                let touch_x = e.targetTouches[0].clientX;

                let touch_percent = ((touch_x - gutter) / (window.innerWidth - (gutter * 2)));

                if (touch_percent <= 1 && touch_percent >= 0) {
                    this.progress_point_position = 'calc(' + (touch_percent * 100) + '% - 10px)';
                    let slide = Math.ceil(touch_percent * this.cards.length);
                    if (slide >= 0) {
                        this.card_swiper.slideTo(slide, 1000, false);
                    }
                }

            },
            mobile_ga: function(number) {
                ga('send', 'event', 'Bespoke 100 Days of Summer', 'cta clicked', number);
            }
        },
        filters: {
            card_number: function(number) {
                if (number < 10) {
                    return "0" + number;
                } else {
                    return number;
                }
            }
        },
        watch: {
            active: function() {
                window.scrollTo(1,0);

				anime({
                    targets: '#cards_mobile',
                    opacity: 1,
                    easing: 'linear',
                    duration: 500,
					complete: () => {

						anime({
							targets: '.swiper-container',
							translateX: ['100%', '0%'],
							elasticity: 50,
							delay: 300
						});

						anime({
							targets: '#card_slider_logo',
							translateY: [100, 0],
							opacity: 1,
							elasticity: 0
						});
					}
                });
            }
        },
        mounted: function() {
			this.window_height = window.innerHeight - 65;

			window.addEventListener('resize', () => {
				this.window_height = window.innerHeight - 65;
			});

            ga('send', 'event', 'Bespoke 100 Days of Summer', 'card next');

            this.card_swiper = new Swiper('.swiper-container', {
                observer: true,
                nextButton: '.swiper-next',
                prevButton: '.swiper-prev',
                onSlideChangeStart: (swiper) => {
                    let progress_percent = ((swiper.activeIndex) / (this.cards.length - 1)) * 100;
                    this.progress_point_position = 'calc(' + progress_percent + '% - 10px)';
                },
                onSlideNextStart: () => {
                    console.log('Slide Next');
                    ga('send', 'event', 'Bespoke 100 Days of Summer', 'card next');
                },
                onSlidePrevStart: () => {
                    console.log('Slide Previous');
                    ga('send', 'event', 'Bespoke 100 Days of Summer', 'card previous');
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';
    #cards_mobile {
        display: none;
        position: fixed;
        top: 45px;
        left: 0;
        width: 100vw;
        height: calc(100% - 45px);
        background-color: $pale_peach;
        opacity: 0;

        &.active {
            display: block;
        }
    }

    #card_slider_logo {
        margin: 20px auto;
		transform: translateY(100px);
		opacity: 0;
    }

    .swiper-container {
        height: calc(100% - 150px);
        transform: translateX(100%);
    }

    .swiper-next, .swiper-prev {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: $dark_pink;
        font-size: 15px;
        padding: 15px;
        z-index: 1;
    }

    .swiper-prev {
        left: 0;
    }

    .swiper-next {
        right: 0;
    }

    .slide_card {
        width: 80%;
        height: 100%;
        margin: auto;
        color: white;
        text-align: center;
        position: relative;

        &.do {
            background-color: $red;

            .slide_card_image {
                mix-blend-mode: multiply;
            }
        }

        &.listen {
            background-color: $orange;
        }

        &.make {
            background-color: $yellow;
        }

        &.buy {
            background-color: $pink;
        }

        &.watch {
            background-color: $peach;
        }

        &.disclaimer {

            .slide_card_content {
                top: calc(50% - 60px);
            }

            .slide_card_button {
                bottom: 60px;
            }

            .slide_card_icon {
                bottom: 60px;
            }
        }
    }

    .slide_card_number {
        position: absolute;
        left: 10px;
        top: 10px;
    }

    .slide_card_image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        mix-blend-mode: overlay;
        opacity: 0.4;
    }

    .slide_content_layer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 30px;
        box-sizing: border-box;
        z-index: 1;
    }

    .slide_card_title {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .slide_card_content {
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(100% - 30px);
        transform: translate(-50%, -50%);
    }

    .slide_card_sponsored {
        text-transform: uppercase;
        font-size: 12px;
        line-height: 15px;
        margin-bottom: 20px;

        &.disclaimer {
            position: absolute;
            margin: 0;
            bottom: 20px;
            left: 0;
            font-size: 10px;
            line-height: 1.25;
            opacity: 0.5;
            padding: 0 30px;
        }
    }

    .slide_card_button {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: 135px;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
    }

    .slide_card_icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    #card_slider_progress {
        position: absolute;
        bottom: 55px;
        left: 10%;
        width: 80%;
        height: 2px;

        #progress_bar {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $dark_pink;
        }

        #progress_point {
            position: absolute;
            top: -10px;
            left: -10px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: $dark_pink;
        }
    }

    #card_slider_legal {
        position: absolute;
        top: 50%;
        left: 10%;
        transform: translateY(-50%);
        width: 80%;
    }

    @media (max-height: 570px) {
        .swiper-container {
            height: calc(100% - 120px);
        }

        .slide_card_teaser {
            font-size: 16px;
            line-height: 16px;
        }

        .slide_card_sponsored {
            font-size: 10px;
            line-height: 10px;
        }

        #card_slider_progress {
            bottom: 25px;
        }
    }

</style>



// WEBPACK FOOTER //
// cards-mobile.vue?7cdf78b6